import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
// import { ReportesRepository } from 'src/app/reporte-ventas/domain/reportes.repository';
// import { ReporteContratosRequest } from 'src/app/reporte-ventas/domain/request/reporte-ventas-request';
import { UtilService, dropdownItems, optionExcelExport } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { FormModule } from 'src/app/shared/modulos/form.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReporteContratosRequest } from '../../domain/reporte-ventas.request';

@Component({
  selector: 'app-reporte-contratos',
  standalone: true,
  imports: [
    CommonModule,
    // FormModule,
    SharedModule
  ],
  templateUrl: './reporte-contratos.component.html',
  styleUrl: './reporte-contratos.component.css'
})
export class ReporteContratosComponent {
  constructor(
    private readonly util: UtilService,
    private readonly servReportes: ReportesRepository
  ) { }

  metadatatable: newmetadate[] = [
    { field: 'cont_codigo', title: 'Codigo de Contrato', inputType: 'text' },
    { field: 'cont_numero', title: 'Numero de Contrato', inputType: 'text' },
    { field: 'cont_descrip', title: 'Descripción', inputType: 'text' },
    { field: 'entc_nomtransportista', title: 'Transportista', inputType: 'text' },
    { field: 'cont_fecemi', title: 'Fecha de emisión', inputType: 'date' },
    { field: 'cont_fecini', title: 'Fecha de inicio', inputType: 'date' },
    { field: 'cont_fecfin', title: 'Fecha Fin', inputType: 'date' },
    { field: 'cons_descrgm', title: 'Regimen', inputType: 'text' },
    { field: 'puer_nombredestino', title: 'Pais Destino', inputType: 'text' },
    { field: 'puer_nombreorigen', title: 'Pais Origen', inputType: 'text' },
    { field: 'cons_descvia', title: 'Via', inputType: 'text' },
    { field: 'tipo_descmnd', title: 'Moneda', inputType: 'text' },
    { field: 'puer_nombre', title: 'puerto origen', inputType: 'text' },
    { field: 'pack_desc', title: 'tipo cntr', inputType: 'text' },
    { field: 'tari_costo', title: 'Costo', inputType: 'text' },
    { field: 'tari_pventa1', title: 'Venta', inputType: 'text' },
    { field: 'tari_profit1', title: 'Profit', inputType: 'text' }
  ]

  group: FormGroup
  ngOnInitGroup(): void {
    const fecha = new Date()
    const fechaAnterior = new Date(fecha.getFullYear(), fecha.getMonth(), 1)

    this.group = new FormGroup({
      transportista: new FormControl(null, null),
      desde: new FormControl(fechaAnterior, null),
      hasta: new FormControl(fecha, null),
      estado: new FormControl("todos", null),
      origen: new FormControl(null, null),
      destino: new FormControl(null, null),
      via: new FormControl(null, null),
      pais: new FormControl(null, null),
      numero: new FormControl(null, null),
      descripcion: new FormControl(null, null),
    })
  }

  ngOnInit(): void {
    this.changeParameters()
    this.ngOnInitGroup()
  }

  Estados: dropdownItems[] = [
    { label: "TODOS", value: "todos" },
    { label: "ACTIVOS", value: "activos" },
    { label: "INACTIVOS", value: "inactivos" }
  ]
  transportistas: any[] = []
  originalpuertos: any[] = []
  puertosOrigen: any[] = []
  puertosDestino: any[] = []
  paises: any[] = []
  via: any[] = []
  async changeParameters() {
    const parametros = await this.util.getParametros()
    this.transportistas = parametros.filter(r => r.tipo === 'TRANSPORTISTA')
    this.paises = parametros.filter(r => r.tipo === 'PAI')
    // this.puertos = parametros.filter(r => r.tipo === 'PUERTO')
    this.originalpuertos = parametros.filter(r => r.tipo === 'PUERTO')
    this.via = this.util.getParameterByType("VIA")
    console.log(parametros)
  }

  datatable: any[] = []
  async search(): Promise<void> {
    try {
      this.datatable = []
      const values = this.group.value
      const request = <ReporteContratosRequest>{}
      request.empr_codigo = 1
      request.cont_codigo = null
      request.entc_codtransportista = values.transportista
      request.cont_fecdesde = values.desde
      request.cont_fechasta = values.hasta
      request.cont_estado = values.estado

      console.log(values.origen)

      request.puer_codorigen = (values.origen && values.origen.length > 0) ? values.origen.map(r => { return { filt_codigoint: parseInt(r), filt_codigovar: '', filt_nombre: '' } }) : []
      request.puer_coddestino = (values.destino && values.destino.length > 0) ? values.destino.map(r => { return { filt_codigoint: parseInt(r), filt_codigovar: '', filt_nombre: '' } }) : []
      request.cons_codvia = values.via
      request.tipo_codpai = (values.pais && values.pais.length > 0) ? values.pais.map(r => { return { filt_codigoint: parseInt(r.codigo), filt_codigovar: '', filt_nombre: '' } }) : []
      request.tari_descripcion = values.descripcion
      request.cont_numero = values.numero

      const response = await this.servReportes.ReporteContratos(request).toPromise()
      this.datatable = response.datos.result.map(r => {
        r.cont_fecemi = r.cont_fecemi ? new Date(r.cont_fecemi) : null
        r.cont_fecini = r.cont_fecini ? new Date(r.cont_fecini) : null
        r.cont_fecfin = r.cont_fecfin ? new Date(r.cont_fecfin) : null
        return r;
      })

    } catch (error) {
      console.log(error)
    }


  }

  export(){
    const option: optionExcelExport = {
      fileName: "Rporte Contratos",
      sheets: [
        {
          data: this.datatable.map(r => {
            return Object.keys(r).reduce((acc, key) => {
              // Convertimos cada clave a mayúsculas
              acc[key.toUpperCase()] = r[key];
              return acc;
            }, {});
          }),
          sheetName: "Datos"
        }],
      typeFile: '.xlsx'
    }
    this.util.ExportExcel(option)
  }

  onChangePortByVia(event) {

    let paises = this.group.value.pais
    console.log(paises)
    if (paises && paises.length > 0) {
      this.puertosOrigen = this.originalpuertos.filter(r => r.tipo === 'PUERTO' && paises.some(e => e.codigo === r.codpais) && r.via === this.group.value.via)
      this.puertosDestino = this.originalpuertos.filter(r => r.tipo === 'PUERTO' && r.via == event.value)
    } else {
      this.puertosOrigen = this.originalpuertos.filter(r => r.tipo === 'PUERTO' && r.via == event.value)
      this.puertosDestino = this.originalpuertos.filter(r => r.tipo === 'PUERTO' && r.via == event.value)
    }

  }

  onChangePortByPais() {

    let paises = this.group.value.pais
    if (paises && paises.length > 0) {
      this.puertosOrigen = this.originalpuertos.filter(r => r.tipo === 'PUERTO' && paises.some(e => e.codigo === r.codpais) && r.via === this.group.value.via)
    }

  }
}
